import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormLabel } from '../../interfaces/form-label';

@Component({
  selector: 'cargoes-form-value',
  template: `
    <ng-container *ngIf="labelName !== null">
      <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <div nz-row>
          <ng-container *ngIf="withUid">
          <div nz-col nzXl="3" nzLg="4" nzMd="24" nzSm="24" nzXs="24" class="label-id">{{labelName.uid}}</div>
          <div nz-col nzXl="10" nzLg="7" nzMd="24" nzSm="24" nzXs="24" class="bold"><span [translate]="labelName.labels[labelIndex]"></span></div>
          <div nz-col nzXl="11" nzLg="11" nzMd="24" nzSm="24" nzXs="24" *ngIf="link == false; else linkText">{{labelValue}}</div>
        </ng-container>
        <ng-container *ngIf="!withUid">
          <div nz-col nzXl="10" nzLg="10" nzMd="24" nzSm="24" nzXs="24" class="bold"><span [translate]="labelName.labels[labelIndex]"></span></div>
          <div nz-col nzXl="14" nzLg="14" nzMd="24" nzSm="24" nzXs="24" *ngIf="link == false; else linkText">
            <div nz-row ngClass="{'highlight-text': selectedVersionLabelValue && selectedVersionLabelValue!==labelValue}">{{labelValue}}</div>
            <div nz-row *ngIf="selectedVersionLabelValue && selectedVersionLabelValue!==labelValue">{{selectedVersionLabelValue}}</div>
          </div>
        </ng-container>
      </div>

      </div>
    </ng-container>
    <ng-template #linkText>
    <div nz-col nzXl="11" nzLg="11" nzMd="24" nzSm="24" nzXs="24"> <a (click)="onLink($event)">{{labelValue}}</a></div>
    </ng-template>
    `,
  styles: ['.idSpan{float:right; color:#aaa;}.tooltip{margin-top:7px;margin-left:5px;}.text-wrap{white-space: nowrap;display:inline-block; max-width: 69%;overflow: hidden;text-overflow: ellipsis;position: relative;top: 4px;}']
})
export class FormValueComponent implements OnInit {

  public withUid = false;

  @Input() public labelName!: FormLabel;
  @Input() public labelIndex= 0;
  @Input() public labelValue!: any;
  @Input() public selectedVersionLabelValue!: any;
  @Input() public link = false;
  @Output() public linkClicked = new EventEmitter<Event>();



  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit():void { }

  onLink(event: Event){
    this.linkClicked.emit(event);
  }


}
